

const {isNumber} = require("lodash");


export const numberWithCommas = (x) => {
    if (x === null) return "0.00"
    let decimals = x.toString().split(".")[1]||"00";
    if (decimals.length === 1) {
        decimals = decimals + "0"
    }
    if (decimals.length > 2) {
        decimals = decimals.substring(0,2)
    }
    return (x.toString().split(".")[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'.'+decimals);
};
export const sF = (x) => {
    if (x === null || x==='-' || !x) return 0;
    if (isNumber(x)) return x;
    return parseFloat(x.replaceAll(",", ''));
}
export const sI = (x) => {
    if (x === null) return 0;
    if (isNumber(x)) return x;
    return parseInt(x.replaceAll(",", ''));
}
export const printFormatNumber = (x) => {
    if(typeof x !== 'string') return x;
    if (x==='-') return x
    const number = parseFloat(x.replace(",", ''))
    if (number === 0) {
        return "-"
    } else {
        if (number < 0) {
            return x.replace("-", "(") + ")"
        } else {
            return x
        }
    }
}
export function fWC(number) {

    const fixedNumber = number.toFixed(2);

    return parseFloat(fixedNumber).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
export const numberFromFormatted = (value) => {
    if (value === null || value === undefined) return 0;
    if (typeof value === "number") return value;
    const cleaned = String(value).replace(/,/g, "").trim();
    const parsed = Number(cleaned);
    return Number.isNaN(parsed) ? 0 : parsed;
};